import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Master
// import MasterReducer from './master/reducer';

// Authentication
import AuthReducer from './auth/reducer'
import UserReducer from "./users/reducer"
//Brands
// import BrandListReducer from "./brand/list/reducer";
// import BrandDataReducer from './brand/reducer';

//Users
// import UserListReducer from "./users/list/reducer"
// import UserDataReducer from "./users/reducer"
// import UserBrandsReducer from "./users/brands/reducer";
import RolesReducer from "./users/roles/reducer"
import { collaborationsReducer } from "./collaborations/reducer";
import legacyCollaborationsReducer from "./legacy-collaborations/reducer";

//Campaigns
// import CampaignsReducer from "./campaigns/reducer";
// import CampaignDetailsReducer from "./campaigns/details/reducer";
// import CampaignRequirementsReducer from "./campaigns/requirements/reducer";
// import CampaignCreativesReducer from "./campaigns/creatives/reducer";
// import CampaignApplicationsReducer from "./campaigns/applications/reducer";
// import CampaignCollaborationsReducer from "./campaigns/collaborations/reducer";
// import CampaignPaymentsReducer from "./campaigns/payments/reducer";
// import CampaignInsightsReducer from "./campaigns/insights/reducer";
// import CampaignPerformanceReducer from "./campaigns/performance/reducer"

import InfluencersReducer from "./influencer/reducer";
// import CollaborationMilestoneReducer from "./campaigns/collaborations/milestones/reducer";
import UIReducer from "./ui/reducer";
import AddressBookReducer from "./addressBook/reducer";
import PermalinkFilesReducer from "./files/reducer";
import { campaignsActivityReducer } from "./campaigns/activity/reducer";
const rootReducer = combineReducers({
    Layout: LayoutReducer,
    // master: MasterReducer,
    auth: AuthReducer,
    users: UserReducer,
    collaborations: collaborationsReducer,
    // brandList: BrandListReducer,
    // brandData: BrandDataReducer,
    // userList: UserListReducer,
    // userData: UserDataReducer,
    // userBrands: UserBrandsReducer,
    roles: RolesReducer,
    // campaigns: CampaignsReducer,
    // campaignRequirements: CampaignRequirementsReducer,
    // campaignCreatives: CampaignCreativesReducer,
    // campaignDetails: CampaignDetailsReducer,
    // campaignApplications: CampaignApplicationsReducer,
    influencers: InfluencersReducer,
    // collaborations: CampaignCollaborationsReducer,
    // campaignPayments: CampaignPaymentsReducer,
    // campaignInsights: CampaignInsightsReducer,
    // campaignPerformance: CampaignPerformanceReducer,
    ui: UIReducer,
    legacyCollaborations: legacyCollaborationsReducer,
    // collaborationMilestones: CollaborationMilestoneReducer,
    addressBook: AddressBookReducer,
    permalinkFiles: PermalinkFilesReducer,
    campaignsActivity: campaignsActivityReducer
});

export default rootReducer;